import { useQuery } from '@tanstack/react-query';

import { getJobs } from '~/services/AwsJobsService';

export function useGetJobs(selectedTab: string) {
  return useQuery({
    queryKey: ['aws-jobs', selectedTab],
    queryFn: () => getJobs(selectedTab),
    select: (data) => data?.result ?? [],
    placeholderData: (previousData) => previousData,
  });
}
